<template>
  <div class="bgwrap" @click="$parent.show_left_nav = false">
    <div
      class="left_nav"
      @click.stop=" a = 1"
    >
      <!--游戏类型-->
      <div class="game_type">
        <div
          class="game_item_left"
          :class="active_menu==0?'active':''"
          @click="goMenu(0)"
        >
          <div class="game_tb">
            <img
              src="../assets/images/common/02.png"
              class="game_img"
              alt=""
            >
          </div>
          <div class="game_name">
            Popular
          </div>
        </div>
        <div
          class="game_item_left"
          :class="active_menu==1?'active':''"
          @click="goMenu(1)"
        >
          <div class="game_tb">
            <img
              src="../assets/images/common/04.png"
              class="game_img"
              alt=""
            >
          </div>
          <div class="game_name">
            Slot
          </div>
        </div>
        <div
          class="game_item_left"
          :class="active_menu==2?'active':''"
          @click="goMenu(2)"
        >
          <div class="game_tb">
            <img
              src="../assets/images/common/06.png"
              class="game_img"
              alt=""
            >
          </div>
          <div class="game_name">
            Blockchain
          </div>
        </div>
        <div
          class="game_item_left"
          :class="active_menu==3?'active':''"
          @click="goMenu(3)"
        >
          <div class="game_tb">
            <img
              src="../assets/images/common/08.png"
              class="game_img"
              alt=""
            >
          </div>
          <div class="game_name">
            Recentes
          </div>
        </div>
          <!-- <div
              class="game_item_left"
              :class="active_menu==4?'active':''"
              @click="goMenu(4)"
          >
              <div class="game_tb">
                <img
                    src="../assets/images/common/10.png"
                    class="game_img"
                    alt=""
                >
              </div>
              <div class="game_name">
                  Melhor jogo
              </div>
          </div> -->
      </div>


      <!-- MP3播放器-->
      <div class="mp3_player">
        <audio-player
          ref="audioPlayer"
          :audio-list="audioList.map(elm => elm.url)"
          :before-play="handleBeforePlay"
          :show-progress-bar="false"
          :show-playback-rate="false"
          theme-color="#977142"
        />
        <div class="music_name">
          {{ currentAudioName || audioList[0].name }}
        </div>
      </div>


      <div
        class="game_record"
        @click="$router.push('gameRecord')"
      >
        <div class="grsvg">
          <img src="../assets/images/index/left04.png">
        </div>
        <div class="grt">
          Recordes de Apostas
        </div>
      </div>

      <div class="active_record">






        <div
          class="active_item acbg1"
          @click="$router.push('person')"
        >
           Perfil
        </div>
        <div
          class="active_item acbg2"
          @click="$router.push('betReward')"
        >
          Rebate
        </div>
        <div
          class="active_item acbg3"
          @click="$router.push('recharge')"
        >
          Depósito
        </div>
        <div
          class="active_item acbg4"
          @click="$router.push('withdraw')"
        >
          Saque
        </div>
        <div
          class="active_item acbg5"
          @click="$router.push('agentData')"
        >
          Meus Indicados
        </div>
        <div
          class="active_item acbg6"
          @click="$router.push('vip')"
        >
          VIP
        </div>
          <div
              class="active_item acbg7"
              @click="$router.push('share')"
          >
              Promoção
          </div>

          <a
              target="_blank"
              class="active_item acbg8"
              :href="$store.state.config.download_url"
          >
              Baixar App
        </a>
          <div
              class="active_item acbg9"
              @click="goSupport"
          >
          Suporte
          </div>
          <div
              class="active_item acbg10"
              @click="goSupport"
          >
          FAQ
          </div>
          
      </div>


      <div class="other_list">
        
        <div
          class="other_item icon-wrap"
          @click="logout()"
        >
          
          <div class="other_text">
            Sair
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Fetch from '../utils/fetch';
import AudioPlayer from '@liripeng/vue-audio-player'

import {
    Icon,
    Cell,
    CellGroup
} from "vant";

Vue.use(Cell).use(CellGroup).use(Icon);

export default {
    name: "User",
    components: {
        AudioPlayer
    },
    data() {
        return {
            currentAudioName: '',
            active_menu:0,
            audioList: [
              {name:""},
            ]
        };
    },
    created() {

    },
    mounted() {
        this.start();
    },
    methods: {
        goMenu(idx) {
            // this.$parent
            this.active_menu = idx;
           
            if(this.$router.currentRoute.name != "index"){
                this.$router.push({path:"index",params:{
                        nav:idx
                    }})
            }else{
                this.$bus.$emit('send2index', idx);
            }

        },
        // 播放前做的事
        handleBeforePlay(next) {
            // 这里可以做一些事情...
            this.currentAudioName = this.audioList[this.$refs.audioPlayer.currentPlayIndex].name

            next() // 开始播放
        },
        start() {
            Fetch('/user/getUserInfoAPi2').then((r) => {
                this.data = r.data;
            });
            Fetch('/index/getMusic').then((r) => {
                this.audioList = r.data;
            });
        },
        goSupport() {
            this.$notify.success({
                title: "atendimento ao Cliente",
                message: "Equipe ao seu serviço 24 horas por dia, 7 dias por semana"
            })
            this.$router.push('support');
        },
        logout() {
            Fetch('/user/logout').then((r) => {
                //console.log(r);
                if (r.code == 1) {
                    this.$router.go(0);
                    localStorage.removeItem('token')
                }
            });
        },

    }
};
</script>

<style lang="less" scoped>
.other_item {
    width: 94%;
    display: flex;
    flex-wrap:wrap;
    margin-bottom: 0.3rem;
    padding-left:.95rem;
}

.icon-wrap {
    background: url("../assets/images/index/left15.png") no-repeat .2rem center;
    background-size:.6rem auto;
    display: flex;
    align-items: center;
    height: .8rem;
}

.other_text {
    height: 0.8rem;
    line-height: 0.8rem;
    color: #694006;
    font-size: 0.36rem;
}

.mp3_player {
    width: 94%;
    background-image: linear-gradient(to right, rgba(244, 210, 162, 1), rgba(250, 229, 197, 1), rgba(244, 210, 162, 1));
    margin: 0 auto 0.1rem auto;
    //overflow: hidden;
    border-radius: 0.2rem;
    padding: 0.2rem 0.1rem;
    box-sizing: border-box;
}

.game_record {
    width: 94%;
    background-image: linear-gradient(to right, rgba(244, 210, 162, 1), rgba(250, 229, 197, 1), rgba(244, 210, 162, 1));
    margin: 0 auto 0.1rem auto;
    //overflow: hidden;
    border-radius: 0.2rem;
    padding: 0.1rem 0.1rem;
    box-sizing: border-box;
    color: #694006;
    display: flex;
}

.other_list {
    width: 94%;
    height: .8rem;
    background-image: linear-gradient(to right, rgba(244, 210, 162, 1), rgba(250, 229, 197, 1), rgba(244, 210, 162, 1));
    margin: 0.1rem auto;
    border-radius: 0.2rem;
    box-sizing: border-box;
    color: #694006;
    line-height: 0.8rem;
}

.active_record {
    width: 94%;
    background-image: linear-gradient(to right, rgba(252, 235, 205, 1), rgba(252, 240, 221, 1));
    margin: 0 auto;
    border-radius: 0.2rem;
    padding: 0.1rem 0.05rem;
    box-sizing: border-box;
    color: #c7c7c7;
    display: flex;
    flex-wrap: wrap;
}

.active_item {
    width: 98%;
    margin: 0 2% 0.2rem 0%;
    height: .6rem;
    color: #694006;
    font-size: 0.36rem;
    line-height: 0.6rem;
    padding-left: .95rem;
}

.acbg1 {
    background: url("../assets/images/index/left05.png") no-repeat .2rem center;
    background-size:.6rem auto;
}

.acbg2 {
  background: url("../assets/images/index/left06.png") no-repeat .2rem center;
    background-size:.6rem auto;
}

.acbg3 {
  background: url("../assets/images/index/left07.png") no-repeat .2rem center;
    background-size:.6rem auto;
}

.acbg4 {
  background: url("../assets/images/index/left08.png") no-repeat .2rem center;
    background-size:.6rem auto;
}

.acbg5 {
  background: url("../assets/images/index/left09.png") no-repeat .2rem center;
    background-size:.6rem auto;

}

.acbg6 {
  background: url("../assets/images/index/left10.png") no-repeat .2rem center;
    background-size:.6rem auto;
}
.acbg7 {
  background: url("../assets/images/index/left11.png") no-repeat .2rem center;
    background-size:.6rem auto;
}
.acbg8 {
  background: url("../assets/images/index/left12.png") no-repeat .2rem center;
    background-size:.6rem auto;
}
.acbg9 {
  background: url("../assets/images/index/left13.png") no-repeat .2rem center;
    background-size:.6rem auto;
}
.acbg10 {
  background: url("../assets/images/index/left14.png") no-repeat .2rem center;
    background-size:.6rem auto;
}

.grsvg {
    display: flex;
    justify-content: flex-end;
}

.grsvg svg {
    width: 1.2rem;
    height: 0.7rem;
}

.grt {
    width: 60%;
    margin-left:.2rem;
    padding-top:.1rem;
    font-size: .36rem;
}

.music_name {
    text-align: center;
    color: #694006;
    margin-top: 0.2rem;
}

.left_nav {
    width: 4rem;
    height: 100%;
    background:rgba(30,30,30,1);
    margin-top: 1.2rem;
}

.bgwrap {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    z-index: 2;
    overflow: hidden;
}

.game_type {
    width: 94%;
    margin: 0 auto .1rem auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    padding-top: 0.35rem;
    border-radius: 0.2rem;
    background-image: linear-gradient(to right, rgba(252, 235, 205, 1), rgba(252, 240, 221, 1));
}

.game_item_left.active {
    background:#fcf0dc;
    color: #694006;
}
.game_item_left.active .game_tb {
  background-image: linear-gradient(to right, #ba955b, #e6cca3);
    color: #694006;
}

.game_item_left {
    width: 42%;
    margin: 0 2% 0 5%;
    padding: 0 0 .2rem 0;
    color: #694006;
    .game_tb{
      width: 1.2rem;
      height: .95rem;
      padding-top: .25rem;
      margin: 0 auto;
      background:#ffffff;
      border-radius: 50%;
    }
}


.game_img {
    width: 0.9rem;
    //height: 0.4rem;
    display: block;
    margin: 0 auto;
}

.game_item_left .game_name {
    text-align: center;
    font-size: 0.25rem!important;
    margin-top: 0.1rem;
    font-weight: 700;
}
</style>
